import i18n from 'i18next'
import HttpApi from 'i18next-http-backend'
import LngDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationNL from '../locales/nl-NL.json'
import translationEN from '../locales/en-GB.json'
import translationDe from '../locales/de-DE.json'

const resources = {
  en: {
    translation: translationEN,
  },
  nl: {
    translation: translationNL,
  },
  de: {
    translation: translationDe,
  },
}

//@ts-ignore
i18n
  .use(LngDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  })

export default i18n
